import Api from "@/api/base";


export default {
    namespaced: true,

    state: {
        loading: false,
        errors: [],
        warnings: [],
    },
    getters: {
        loading(state) {
            return state.loading
        },
        errors(state) {
            return state.errors;
        },
        warnings(state) {
            return state.warnings;
        },
    },
    actions: {
        loadErrors(ctx, payload) {
            if( !ctx.rootState.card.card.id ){
                return;
            }
            ctx.commit('setLoading', true);
            Api.card.getCardErrors({
                id: ctx.rootState.card.card.id
            })
                .then((data) => {
                    ctx.commit('updateErrors', data.errors);
                    ctx.commit('updateWarnings', data.warnings);
                })
                .finally(() => {
                    ctx.commit('setLoading', false);
                })

        },

        unloadErrors(ctx){
            ctx.commit('updateErrors', []);
            ctx.commit('updateWarnings', []);
        },

    },

    mutations: {
        setLoading(state, isLoading) {
            state.loading = isLoading;
        },
        updateErrors(state, errors) {
            state.errors = errors;
        },
        updateWarnings(state, warnings) {
            state.warnings = warnings;
        },
    }
}